import React, { Component } from 'react';
import { withApollo, compose } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { withFormik } from 'formik';

import { DetachClaimsPassengerTicket } from '../../../mutations/DetachClaimsPassengerTicket';
import { DetachFlight } from '../../../mutations/DetachFlight';
import { formikConfig } from './formikConfig';
import TaskView from './TaskView';
import withClaimQuery from './withClaimQuery';
import scrollToError from '../../../utils/scrollToError';

class CorrectClaimTask extends Component {
  state = {};

  componentDidUpdate(prevProps) {
    const { isSubmitting, isValid, errors } = this.props;
    if (prevProps.isSubmitting && !isSubmitting && !isValid)
      scrollToError(errors);
  }

  handleChange = (e, { name, value }) => this.props.setFieldValue(name, value);

  handlePassengerChange = (id, e, { name, value }) => {
    const { setFieldValue, values } = this.props;
    setFieldValue(
      'passengers',
      values.passengers.map(p => (p.id === id ? { ...p, [name]: value } : p))
    );
  };
  handleFlightChange = (id, e, { name, value }) => {
    const { setFieldValue, values } = this.props;
    setFieldValue(
      'flights',
      values.flights.map(f => (f.id === id ? { ...f, [name]: value } : f))
    );
  };
  handleFlightTimeChange = (id, field, value) => {
    const { setFieldValue, values } = this.props;
    setFieldValue(
      'flights',
      values.flights.map(f => (f.id === id ? { ...f, [field]: value } : f))
    );
  };
  handleBlur = name => this.props.setFieldTouched(name, true);

  handleRemoveFlight = flightId => {
    const { claim, client, refetch } = this.props;
    const { passengerTicketId } = claim;
    this.setState({ loading: true });
    client
      .mutate({
        mutation: DetachFlight,
        variables: {
          input: {
            flightId,
            passengerTicketId
          }
        }
      })
      .then(() => {
        refetch();
        this.setState({ loading: false });
      })
      .catch(() => this.setState({ loading: false }));
  };
  handleRemovePassenger = passengerTicketId => {
    const { claim, client, refetch } = this.props;
    const claimId = claim.id;
    if (!passengerTicketId) return;
    client
      .mutate({
        mutation: DetachClaimsPassengerTicket,
        variables: {
          input: {
            passengerTicketId,
            claimId
          }
        }
      })
      .then(() => {
        refetch();
        this.setState({ loading: false });
      })
      .catch(() => this.setState({ loading: false }));
  };
  handleCancel = () => this.props.history.goBack();

  render() {
    const { loading, ...restProps } = this.props;
    return (
      <TaskView
        {...restProps}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        onCancel={this.handleCancel}
        onPassengerChange={this.handlePassengerChange}
        onFlightChange={this.handleFlightChange}
        loading={loading || this.props.isSubmitting || this.state.loading}
        onFlightTimeChange={this.handleFlightTimeChange}
        onRemoveFlight={this.handleRemoveFlight}
        onRemovePassenger={this.handleRemovePassenger}
      />
    );
  }
}

export default compose(
  withRouter,
  withApollo,
  withClaimQuery,
  withFormik(formikConfig)
)(CorrectClaimTask);



// WEBPACK FOOTER //
// ./src/component/tasks/CorrectClaimTask/index.js